import React from 'react';
import ClassNames from 'classnames';
import EnhancedSwitch from '../enhanced-switch/EnhancedSwitch';
import RadioButtonOff from 'components/svg-icons/toggle-radio-button-off';
import RadioButtonOn from 'components/svg-icons/toggle-radio-button-on';

export default React.createClass({

	propTypes: {
		onCheck: React.PropTypes.func,
		value: React.PropTypes.string,
		label: React.PropTypes.string,
		defaultCheck: React.PropTypes.bool,
		disabled: React.PropTypes.bool
	},

	getInitialState(){
		return {
			onCheck: this.props.onCheck
		}
	},

	render() {

		let radioButtonElement = (
			<div>
				<RadioButtonOff className="lui-radio-button-target" />
				<RadioButtonOn className="lui-radio-button-fill" />
			</div>
		);

		let enhancedSwitchProps = {
			ref: "enhancedSwitch",
			inputType: "radio",
			switchElement: radioButtonElement,
			className: "lui-radio-button",
			iconClassName: "lui-radio-button-icon",
			onSwitch: this._handleCheck,
			labelPosition: (this.props.labelPosition) ? this.props.labelPosition : "right"
		};

		return (
			<EnhancedSwitch
				onCheck={this.state.onCheck}
				{...this.props}
				{...enhancedSwitchProps} />
		);
	},

	// Only called when selected, not when unselected.
	_handleCheck(e) {
		setTimeout(()=> {
			this.props.onCheck(e, this.props.value);
		}, 1);
	},

	setOnCheck(func){
		this.setState({
			onCheck: func
		})
	},

	isChecked() {
		return this.refs.enhancedSwitch.isSwitched();
	},

	setChecked(newCheckedValue) {
		this.refs.enhancedSwitch.setSwitched(newCheckedValue);
		this.setState({
			switched: newCheckedValue
		});
	},

	getValue() {
		return this.refs.enhancedSwitch.getValue();
	}
});



/** WEBPACK FOOTER **
 ** ./src/components/forms/radio/Radio.js
 **/